import { useTranslation } from 'react-i18next';
import { SttButton, SttDialog } from '../../../sporttia/all';

type Props = {
    open: boolean;
    onResponse: (response: boolean) => void;
    onClose: () => void;
};

export default function BookingScheduleDeleteDialog({
    open,
    onResponse,
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SttDialog
            open={open}
            onClose={onClose}
            title={t('removeFixedRental')}
            buttons={[
                {
                    type: 'component',
                    component: (
                        <SttButton
                            caption={t(`Yes`)}
                            onClick={() => onResponse(true)}
                        />
                    ),
                },
                {
                    type: 'component',
                    component: (
                        <SttButton
                            caption={t(`No`)}
                            onClick={() => onResponse(false)}
                        />
                    ),
                },
            ]}
            content={<div>{t('question.remove.fixedRentals')}</div>}
        />
    );
}
